// https://vuex.vuejs.org/en/actions.html

import NewApiService from "@/utils/new.api.service";

export default {
  
  get(ctx, model) {
    return new Promise((resolve, reject) => {
        NewApiService.get("products/"+model.id+"/stock-logs")
        .then(({data}) => {
            resolve(data)
        })
        .catch(({ response }) => {
            reject(response)
        });
    });
  },

};
